import { el, escape } from './dom';

export type TrustSectionProps = {
  body?: string;
};

const DEFAULT_BODY =
  "after the app loads, anything new in your network tab is the browser fetching code or a model — never your file. open any request: it's a GET to a CDN, not a POST with your data. once the model is cached, even those go quiet.";

export const TrustSection = (props: TrustSectionProps = {}): HTMLElement => {
  const body = escape(props.body ?? DEFAULT_BODY);

  return el(`
    <section class="trust" id="trust">
      <div class="container">
        <div class="trust-grid">
          <div>
            <h2>open DevTools. switch to network. drop a file. <span class="accent">watch your file never leave your tab.</span></h2>
            <p class="body">${body}</p>
          </div>

          <div class="devtools">
            <div class="devtools-tabs">
              <div class="devtools-tab">Elements</div>
              <div class="devtools-tab">Console</div>
              <div class="devtools-tab">Sources</div>
              <div class="devtools-tab active">Network</div>
              <div class="devtools-tab">Performance</div>
            </div>
            <div class="devtools-toolbar">
              <span class="devtools-record"></span>
              <span class="devtools-toolbar-text">Filter</span>
            </div>
            <div class="devtools-headers">
              <span>Name</span>
              <span>Status</span>
              <span>Type</span>
              <span>Initiator</span>
              <span>Size</span>
            </div>
            <div class="devtools-empty">
              <div class="devtools-zero">0</div>
              <div class="devtools-empty-text">uploads of your file</div>
              <div class="devtools-empty-text">↑ everything else is code loading locally</div>
            </div>
            <div class="devtools-status">
              <span>0 file uploads · cached code only</span>
              <span>anomia.app</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  `);
};
